export const CENTER_URL = "https://rtcenter.org/";
export const BASE_URL = "https://ecommerce.rta.vn/api/";
export const SOCKET_URL = "wss://ws.rta.vn";
// export const BASE_URL = "http://139.162.33.51:8181/api/";
// export const SOCKET_URL = "ws://139.162.33.51:8081";
